import { FC, SVGProps } from 'react';

export const Filter2Icon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 4.66675H14" stroke="#141414" strokeLinecap="round" />
    <path d="M4 8H12" stroke="#141414" strokeLinecap="round" />
    <path d="M6.66406 11.3333H9.33073" stroke="#141414" strokeLinecap="round" />
  </svg>
);
